import { z } from 'zod'

export const ticketRequestSchema = z
	.object({
		type: z.string(),
		description: z.string().min(1),
	})
	.strict()
// .superRefine((data, ctx) => {
// 	if (data.type === '9') {
// 		if (!data.provider) {
// 			ctx.addIssue({
// 				path: ['provider'],
// 				message: 'Required',
// 				code: z.ZodIssueCode.custom,
// 			})
// 		}

// 		if (
// 			!data.insuranceCompanies ||
// 			data.insuranceCompanies.length === 0
// 		) {
// 			ctx.addIssue({
// 				path: ['insuranceCompanies'],
// 				message: 'Required',
// 				code: z.ZodIssueCode.custom,
// 			})
// 		}

// 		if (!data.medicalAct || data.medicalAct.length === 0) {
// 			ctx.addIssue({
// 				path: ['medicalAct'],
// 				message: 'Required',
// 				code: z.ZodIssueCode.custom,
// 			})
// 		}
// 		if (
// 			data.medicalAct &&
// 			data.medicalAct.length > 0 &&
// 			!data.medicalActPrices
// 		) {
// 			ctx.addIssue({
// 				path: ['medicalActPrices'],
// 				message: 'Required',
// 				code: z.ZodIssueCode.custom,
// 			})
// 		}
// 	}
// })

export const ticketNullifyRequestSchema = z
	.object({
		reason: z.string().min(1),
	})
	.strict()
